"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FollowButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const button_styles_1 = require("@/components/common/button/button.styles");
const button_utils_1 = require("@/components/common/button/button.utils");
const shared_styles_1 = require("@/stylesheets/shared.styles");
let FollowButton = class FollowButton extends (0, button_utils_1.withTogglePressed)(lit_1.LitElement) {
    render() {
        return (0, lit_1.html) `
      <button
        type="button"
        ?disabled=${this.disabled}
        aria-pressed=${this.pressed ? 'true' : 'false'}
        @click=${this.handleToggleClick}
      >
        ${this.pressed ? '팔로우 중' : '팔로우'}
      </button>
    `;
    }
};
FollowButton.styles = [shared_styles_1.resetStyles, button_styles_1.buttonBaseStyles, button_styles_1.followButtonStyles, button_styles_1.buttonSelectedStyles];
FollowButton = __decorate([
    (0, decorators_js_1.customElement)('mm-follow-button')
], FollowButton);
exports.FollowButton = FollowButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9sbG93LWJ1dHRvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImZvbGxvdy1idXR0b24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQXNDO0FBQ3RDLHFEQUFpRDtBQUVqRCw0RUFJaUQ7QUFDakQsMEVBQTJFO0FBQzNFLCtEQUF5RDtBQUdsRCxJQUFNLFlBQVksR0FBbEIsTUFBTSxZQUFhLFNBQVEsSUFBQSxnQ0FBaUIsRUFBQyxnQkFBVSxDQUFDO0lBRzdELE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7b0JBR0ssSUFBSSxDQUFDLFFBQVE7dUJBQ1YsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxPQUFPO2lCQUNyQyxJQUFJLENBQUMsaUJBQWlCOztVQUU3QixJQUFJLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLEtBQUs7O0tBRW5DLENBQUE7SUFDSCxDQUFDOztBQWJNLG1CQUFNLEdBQUcsQ0FBQywyQkFBVyxFQUFFLGdDQUFnQixFQUFFLGtDQUFrQixFQUFFLG9DQUFvQixDQUFDLENBQUE7QUFEOUUsWUFBWTtJQUR4QixJQUFBLDZCQUFhLEVBQUMsa0JBQWtCLENBQUM7R0FDckIsWUFBWSxDQWV4QjtBQWZZLG9DQUFZIn0=